import {Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild} from "@angular/core";
import {
  Merchant,
  OrderControllerService,
  PaymentControllerService,
  PaymentMethodControllerService,
} from '../../@services/gen';
import { kickCashDrawerz, lcdScreen, printz, secondScreen } from "../../@services/utils";
import {AuthService} from '../../@services/auth.service';
import {PaymentService} from '../../@services/payment.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UserModel} from '../../@models/user.model';
import {LocalstorageService} from '../../@services/localstorage.service';
import {NotificationService} from '../../@services/notification.service';
import {Payment} from '../../@services/gen/model/payment';
import {ReceiptService} from '../../@services/receipt.service';
import {FeatureService} from '../../@services/feature.service';

@Component({
  selector: 'app-payment-result',
  templateUrl: './payment-result.component.html',
  styleUrls: ['./payment-result.component.scss'],
})
export class PaymentResultComponent implements OnInit {
  @ViewChild('referenceNoRef') referenceNoRef: ElementRef;
  @ViewChild('paidAmountRef') paidAmountRef: ElementRef;

  paidAmount: number;
  totalAmount: number = 0;
  table: string | undefined;
  payment: Payment;
  user: UserModel;
  merchant: Merchant = {};
  isMobile: boolean = false;

  constructor(
    private orderService: OrderControllerService,
    private paymentService: PaymentControllerService,
    private paymentMethodService: PaymentMethodControllerService,
    private customAuthService: AuthService,
    private customPaymentService: PaymentService,
    private customReceiptService: ReceiptService,
    private fs: FeatureService,
    private router: Router,
    private route: ActivatedRoute,
    private ls: LocalstorageService,
    private ns: NotificationService,
    private renderer: Renderer2,
    private elementRef: ElementRef
  ) {
    this.checkIsMobile();
  }

  ngOnInit(): void {
    this.user = this.customAuthService.getUser();
    this.merchant = this.ls.getMerchant();

    this.route.queryParams.subscribe((qp) => {
      let paymentIdParam = qp['paymentId'];
      if (paymentIdParam) {
        this.paymentService.getPaymentGet(+paymentIdParam).subscribe((payment) => {
          this.payment = payment;

          if (this.isCash() && payment.changeAmount >= 0) {
            kickCashDrawerz();
          }

          if (this.fs.isFeatureEnabled("lcdScreen") && !this.isMobile) {
            lcdScreen(["Payment ✔", "Thank you!"]);
          }

          if (!this.isMobile) {
            secondScreen({
              backgroundUrl: this.merchant.secondScreenBanner,
              merchantName: this.merchant.storeName || this.merchant.companyName,
              merchantLogoUrl: this.merchant['merchantLogoSmall'],
              orderItems: payment.paymentItems.flatMap((p) => p.order.orderItems),
              payment: payment,
              discountAmount: payment.discountAmount,
              discountItemAmount: payment.discountItemAmount,
              netAmount: payment.netAmount,
              quantity: payment.paymentItems.flatMap((p) => p.order.orderItems).reduce((a, b) => a + b.quantity, 0),
              roundingAmount: payment.roundingAmount,
              subtotal: payment.totalAmount,
              tax1Amount: payment.tax1Amount,
              tax2Amount: payment.tax2Amount,
              totalAmount: payment.totalAmount,
            });
          }
        });
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkIsMobile();
  }

  private checkIsMobile() {
    this.isMobile = window.innerWidth < 768; // You can adjust the threshold as needed

    if(this.isMobile){
      this.renderer.setStyle(this.elementRef.nativeElement, 'padding-left', '10px');
      this.renderer.setStyle(this.elementRef.nativeElement, 'padding-right', '10px');
    }
  }

  reprintReceipt() {
    let posId = this.ls.getPosId();
    for (let mvp of this.merchant.merchantVsPrinters.filter(x => x.posId === posId || !x.posId)) {
      let dialogRef = this.ns.showNotification({
        message: 'Reprint receipt',
        manualClose: true,
        icon: 'fa fa-sync',
      });

      if (mvp.printReceipt) {
        // chakz testing
        if (this.fs.isFeatureEnabled('receiptHTML')) {
          this.customReceiptService.getPaymentReceiptHtml(
            this.payment.id,
            mvp.printer.paperSizeType == 'BIG' ? 85 : 56,
            mvp.printer.paperSizeType == 'BIG' ? 570 : 380,
            (res) => {
              dialogRef.close();

              if (!res) {
                console.log('No receipt data');
                return;
              }

              printz(
                {
                  printerName: mvp.printer.printerName,
                  printerType: mvp.printer.printerType,
                  vendorId: mvp.printer.printerVendorId,
                  ipAddress: mvp.ipAddress,
                  macAddress: mvp.macAddress,
                  paperSizeType: mvp.printer.paperSizeType,
                },
                [res],
                'html'
              );
            }
          );
        } else {
          this.customPaymentService.getPaymentReceipt(
            this.payment.id,
            mvp.printer.paperSizeType == 'BIG' ? 45 : 32,
            (res) => {
              dialogRef.close();

              if (!res) {
                console.log('No receipt data');
                return;
              }

              printz(
                {
                  printerName: mvp.printer.printerName,
                  printerType: mvp.printer.printerType,
                  vendorId: mvp.printer.printerVendorId,
                  ipAddress: mvp.ipAddress,
                  macAddress: mvp.macAddress,
                  paperSizeType: mvp.printer.paperSizeType,
                },
                [res]
              );
            }
          );
        }
      } else {
        dialogRef.close();
      }
    }
  }

  kickCashDrawer() {
    kickCashDrawerz();
  }

  isCash() {
    return this.payment.paymentMethod.name.toLowerCase() === 'cash';
  }
}
